import { useSettings } from '@sparklayer-io/spark-dash-core/context/settings-context';
import type { CustomersSyncApiSettings } from '../api';

export function useCustomersSyncSettings(): CustomersSyncApiSettings {
  const settings = useSettings();
  return {
    useCustomersAPI: !!settings.useCustomersAPI,
    dualWriteToCustomersAPI: !!settings.dualWriteToCustomersAPI,
  };
}
